import userMustChangePasswordCheck from "./userMustChangePasswordCheck";
import { useAuthUserStore } from "@/stores/authUser";
export default function auth(requiresPasswordReset = true) {
    return ({ to, from }) => {
        const authUserStore = useAuthUserStore();
        if (!authUserStore.check) {
            return {
                name: "login"
            };
        }

        if (requiresPasswordReset) {
            return userMustChangePasswordCheck({to, from });
        }
    };
}
